import { colorPallet as color } from './ColorPallet';
import { DefaultTheme } from 'styled-components';
export const scale = (size: number): number => size;

const defaultStyles = {
  radii: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '10px',
    xl: '12px',
    xxl: '22px',
    xxxl: '32px',
    full: '1000px'
  },
  // fonts: {
  //   body: body.style.fontFamily,
  //   bold: bold.style.fontFamily,
  //   regular: regular.style.fontFamily
  // },
  fontSizes: [
    '1rem', // 0
    '1.1rem', // 1
    '1.2rem', // 2
    '1.3rem', // 3
    '1.4rem', // 4
    '1.5rem', // 5
    '1.6rem', // 6
    '1.7rem', // 7
    '1.8rem', // 8
    '1.9rem', // 9
    '2rem', // 10
    '2.1rem', // 11
    '2.2rem', // 12
    '2.3rem', // 13
    '2.4rem', // 14
    '2.5rem', // 15
    '2.6rem', // 16
    '2.7rem', // 17
    '2.8rem', // 18
    '2.9rem', // 19
    '3.1rem', // 20
    '3.2rem', // 21
    '3.3rem', // 22
    '3.4rem', // 23
    '3.5rem', // 24
    '3.6rem', // 25
    '3.7rem', // 26
    '3.8rem', // 27
    '3.9rem', // 28
    '4rem', // 29
    '4.5rem', // 30
    '5rem', // 31
    '5.5rem' // 32
  ],
  fontWeights: [
    'normal', // 0
    'bold', // 1
    100, // 2
    200, // 3
    300, // 4
    400, // 5
    500, // 6
    600, // 7
    700, // 8
    800, // 9
    900 // 10
  ],
  borders: [
    '1px solid', // 0
    '1px dashed', // 1
    '1px dotted', // 2
    '2px solid', // 3
    '2px dashed', // 4
    '2px dotted', // 5
    '3px solid', // 6
    '3px dashed', // 7
    '3px dotted' // 8
  ],
  shadows: {
    input: '0px 0px 0px 2px rgba(24, 144, 255, 0.2)',
    box: '0px 5px 15px rgba(0, 0, 0, 0.15)',
    header: '0 10px 10px 0 rgba(0, 0, 0, 0.05)',
    search: '0px 4px 6px rgba(0, 0, 0, 0.12)',
    tab: '0px 10px 14px rgba(0, 0, 0, 0.05)'
  },
  space: [
    scale(0), // 0
    scale(1), // 1
    scale(2), // 2
    scale(4), // 3
    scale(6), // 4
    scale(8), // 5
    scale(10), // 6
    scale(12), // 7
    scale(16), // 8
    scale(20), // 9
    scale(24), // 10
    scale(28), // 11
    scale(32), // 12
    scale(36), // 13
    scale(40), // 14
    scale(44), // 15
    scale(48), // 16
    scale(52), // 17
    scale(56), // 18
    scale(60), // 19
    scale(64), // 20
    scale(80), // 21
    scale(96), // 22
    scale(112), // 23
    scale(128), // 24
    scale(144), // 25
    scale(160), // 26
    scale(176), // 27
    scale(192), // 28
    scale(208), // 29
    scale(224), // 30
    scale(240), // 31
    scale(256) // 32
  ],

  sizes: [
    scale(0), // 0
    scale(1), // 1
    scale(2), // 2
    scale(4), // 3
    scale(6), // 4
    scale(8), // 5
    scale(10), // 6
    scale(12), // 7
    scale(16), // 8
    scale(20), // 9
    scale(24), // 10
    scale(28), // 11
    scale(32), // 12
    scale(36), // 13
    scale(40), // 14
    scale(44), // 15
    scale(48), // 16
    scale(52), // 17
    scale(56), // 18
    scale(60), // 19
    scale(64), // 20
    scale(80), // 21
    scale(96), // 22
    scale(112), // 23
    scale(128), // 24
    scale(144), // 25
    scale(160), // 26
    scale(176), // 27
    scale(192), // 28
    scale(208), // 29
    scale(224), // 30
    scale(240), // 31
    scale(256) // 32
  ],
  zIndices: [
    -1, // 0
    0, // 1
    1, // 2
    2, // 3
    3, // 4
    4, // 5
    5, // 6
    10, // 7
    100, // 8
    101, // 9
    102, // 10
    103, // 11
    104, // 12
    105, // 13
    1000, // 14
    1001, // 15
    1002, // 16
    1003, // 17
    1004, // 18
    1005, // 19
    2000 // 20
  ]
};
const light: DefaultTheme = {
  ...defaultStyles,
  colors: {
    mainBackground: color.white,
    secondaryBackground: color.greyF3,
    danger: color.semRed,
    border: color.greyD9,
    disableBg: color.greyD9,
    disableColor: color.greyBa,
    line: color.greyF3,
    primaryGreen: color.primaryNeon,
    lightGreen: color.lightGreen,
    greenTag: color.viper700,
    secondaryGreen: color.semGreen,
    normalText: color.neutralHigh,
    secondaryText: color.neutralMid,
    minorText: color.neutralLow,
    buttonText: color.neutralHigh,
    secondaryButtonText: color.white,
    primaryPurple: color.primaryPurple,
    primaryBlue: color.semBlue,
    lightBlue: color.lightBlue,
    primaryYellow: color.primaryYellow,
    male: color.semMale,
    female: color.semFemale,
    dark80: color.dark80
  }
};
const dark: DefaultTheme = {
  ...defaultStyles,
  colors: {
    ...color
  }
};

export { light, dark };
